// extracted by mini-css-extract-plugin
export var dropdown = "_ty-0";
export var imageWrapper = "_ty-3";
export var itemNameContainer = "_ty-1";
export var productImage = "_ty-2";
export var spinnerWrapper = "_ty-4";